<span id="signout" *ngIf="this.router.url !==  '/photocontest'">
    <a id="funBtn" class="submitBtn" (click)="submitPageAnalytics('click_Logout');exit();" data-bs-toggle="tooltip"
        role="button">
        Logout
    </a>
</span>





<div class="livemsg" id="countdown" style="display: none;">

</div>
<span id="goBack"
    [ngStyle]="{'display': (router.url.includes('exhibition') || router.url.includes('photobooth')) || router.url.includes('signaturewall') || router.url.includes('bpclstories') || router.url.includes('cheeritout') || router.url.includes('photocontest')|| router.url.includes('archivesocratix') || router.url.includes('archiverytink') || router.url.includes('archivemercurix') || router.url.includes('bpclstoryarchive') || router.url.includes('archiveipassion') || router.url.includes('litwit')?'block':'none'}">
    <a id="funBtn" class="submitBtn" (click)="gotoBack()" data-bs-toggle="tooltip" role="button">
        Back
    </a>
</span>
<router-outlet></router-outlet>
<app-menu (outputMenu)="readOutputMenu($event)"></app-menu>
<app-briefcase-modal></app-briefcase-modal>
<app-leaderboard-modal></app-leaderboard-modal>
<app-welcome-chat></app-welcome-chat>